/* fb-commerce.js — Empire-independent quick-add for product cards.

   Owns the card "agregar a carrito" button. The theme renders `[data-quick-buy]`
   ONLY for single-variant products (see snippets/product-grid-item.liquid: it emits
   data-quick-buy when `unless has_variants`, else data-quickshop-slim), so the variant
   id sits right on the button in `data-variant-id` — no form, no variant picker needed.

   Empire used to be the only glue here: click → POST /cart/add.js → cart changes →
   Rebuy's flyout opens. None of that needs Empire. This file does the add directly;
   Rebuy (a third-party app) opens itself on the cart change, and fb-chrome.js refreshes
   the header count (it wraps window.fetch and listens for cart events).

   Double-add safety: we bind on document in the CAPTURE phase and call
   stopImmediatePropagation, so even if Empire later loads and binds its own delegated
   click handler, it never fires for these buttons. Multi-variant quick-shop is a
   separate, later step and is intentionally left to Empire for now. */
(function () {
  'use strict';

  var SEL = '[data-quick-buy]';

  function cartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '/') + 'cart/add.js';
  }

  function addToCart(variantId) {
    return window.fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; }, function () { throw res; });
      return res.json();
    });
  }

  /* Rebuy SmartCart normally auto-opens when it detects the add. Because Rebuy
     loads lazily (on first interaction) it may patch fetch AFTER our add fires, so
     we nudge it open defensively. Framework-agnostic: if Rebuy is ever removed, the
     dispatched cart events still drive fb-chrome's count + any other listeners. */
  function announceCart() {
    try {
      var sc = window.Rebuy && window.Rebuy.SmartCart;
      if (sc) {
        if (typeof sc.refresh === 'function') sc.refresh();
        if (typeof sc.show === 'function') sc.show();
      }
    } catch (e) { /* never let Rebuy break the add */ }
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  function flash(btn, cls, ms) {
    btn.classList.add(cls);
    window.setTimeout(function () { btn.classList.remove(cls); }, ms);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return; // malformed button — don't claim it

    // We own this click — keep Empire's delegated handler from also adding.
    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.hasAttribute('disabled') || btn.classList.contains('processing')) return;

    btn.classList.add('processing');           // theme.css spinner state
    btn.setAttribute('aria-busy', 'true');

    addToCart(variantId)
      .then(function () { announceCart(); })
      .catch(function () { flash(btn, 'atc--error', 1500); })
      .then(function () {
        btn.classList.remove('processing');
        btn.removeAttribute('aria-busy');
      });
  }, true); // capture
})();
